import { List as MuiList, Stack } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

import {
  ListItem,
  ListItemProps,
  ListSubheader,
  ListSubheaderProps,
} from './components';

export type ListItemInfo = Pick<ListItemProps, 'name' | 'path' | 'title' | 'handleClick'>;

export interface ListProps {
  items: ListItemInfo[];
  subheaderInfo?: ListSubheaderProps;
  isCombined?: boolean;
  spacing?: number;
  valueHolderVariant?: Variant;
  isHomepage?: boolean;
  selectedLocation?: string;
  planYearContext?: string;
}

export const List = ({
  items,
  subheaderInfo,
  isCombined = true,
  valueHolderVariant,
  isHomepage,
  selectedLocation,
  planYearContext
}: ListProps) => {
  return (
    <MuiList
      data-testid="list"
      disablePadding
      subheader={subheaderInfo && <ListSubheader {...subheaderInfo} />}
      sx={{ width: '100%' }}
    >
      <Stack
        sx={{
          ...(isHomepage && {
            display: { lg: 'flex' },
            flexDirection: { lg: 'row' },
            padding: { lg: 0 },
            justifyContent: 'space-between',
          }),
        }}
      >
        {items.map((item, index) => (
          <ListItem
            key={index}
            {...item}
            isCombined={isCombined}
            valueHolderVariant={valueHolderVariant}
            className={isHomepage ? 'homepage' : ''}
            selectedLocation={selectedLocation}
            planYearContext={planYearContext}
          />
        ))}
      </Stack>
    </MuiList>
  );
};
